module.exports = __webpack_public_path__ + "img/Standard Bank.e2b9f641.png";